import * as jsep from 'jsep';
import { Injectable } from '@angular/core';

export interface BooleanLookup {
  (x: string): boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PermissionParserService {
  private binaryOperations: {
    '&&': (a: boolean | undefined, b: boolean | undefined) => boolean;
    '||': (a: boolean | undefined, b: boolean | undefined) => boolean;
  } = {
    '&&': function (a: boolean | undefined, b: boolean | undefined): boolean {
      if (a === undefined || b === undefined) {
        return false;
      }
      return a && b;
    },
    '||': function (a: boolean | undefined, b: boolean | undefined): boolean {
      if (a === undefined || b === undefined) {
        return false;
      }
      return a || b;
    },
  };

  private unaryOperations: {
    '!': (a: boolean | undefined) => boolean;
  } = {
    '!': function (a: boolean | undefined): boolean {
      return !a;
    },
  };

  private doEval(node: any, lookup: BooleanLookup): boolean {
    if (node.type === 'LogicalExpression') {
      return this.binaryOperations[node.operator as '&&' | '||'](
        this.doEval(node.left, lookup),
        this.doEval(node.right, lookup),
      );
    } else if (node.type === 'UnaryExpression') {
      const operator = node.operator as keyof typeof this.unaryOperations;
      return this.unaryOperations[operator](this.doEval(node.argument, lookup));
    } else if (node.type === 'Identifier') {
      return lookup(node.name);
    } else {
      return false;
    }
  }

  constructor() {}

  parse(componentExpression: string, lookup: BooleanLookup): boolean {
    let tree = jsep(componentExpression);
    return this.doEval(tree, lookup);
  }
}
